/**
 * Kazakh date parts for runtimes whose Intl has no kk CLDR data (some Chromium
 * builds fall back to the root locale and print "M11 4, Wed"). The names follow
 * the CLDR kk data, so a fallback date looks the same as a formatted one.
 */
const MONTHS = [
  "қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым",
  "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан",
];
const MONTHS_SHORT = [
  "қаң.", "ақп.", "нау.", "сәу.", "мам.", "мау.",
  "шіл.", "там.", "қыр.", "қаз.", "қар.", "жел.",
];
const WEEKDAYS = ["жексенбі", "дүйсенбі", "сейсенбі", "сәрсенбі", "бейсенбі", "жұма", "сенбі"];
const WEEKDAYS_SHORT = ["жс", "дс", "сс", "ср", "бс", "жм", "сб"];

/** Formats a date with Kazakh names, mirroring the option shapes used in the UI. */
export function formatKkDate(date: Date, opts: Intl.DateTimeFormatOptions = {}): string {
  const parts: string[] = [];
  if (opts.weekday) {
    parts.push(opts.weekday === "long" ? WEEKDAYS[date.getDay()] : WEEKDAYS_SHORT[date.getDay()]);
  }
  const day = String(date.getDate());
  const year = opts.year === "2-digit" ? String(date.getFullYear()).slice(-2) : String(date.getFullYear());
  let datePart = "";
  if (opts.month) {
    const month =
      opts.month === "long"
        ? MONTHS[date.getMonth()]
        : opts.month === "short"
          ? MONTHS_SHORT[date.getMonth()]
          : opts.month === "2-digit"
            ? String(date.getMonth() + 1).padStart(2, "0")
            : String(date.getMonth() + 1);
    datePart = opts.day ? day + " " + month : month;
  } else if (opts.day) {
    datePart = day;
  }
  if (opts.year) datePart = datePart ? datePart + " " + year : year;
  if (datePart) parts.push(datePart);
  if (opts.hour || opts.minute) {
    const time = String(date.getHours()).padStart(2, "0") + ":" + String(date.getMinutes()).padStart(2, "0");
    if (parts.length && (datePart || opts.weekday)) parts[parts.length - 1] += ", " + time;
    else parts.push(time);
  }
  return parts.join(", ");
}
